import React from "react";
import ReactDOM from "react-dom";
import { ToastContainer } from "react-toastify";
import App from "./App";
import { AppProviders } from "./context";
import "./tailwind.output.css";

ReactDOM.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
    <ToastContainer />
  </React.StrictMode>,
  document.getElementById("root")
);
